import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';

const Label = styled(Translate)`
	display: block;
	margin-bottom: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Black};
`;

const Button = styled('button')`
	width: 100%;
	height: 44px;
	padding: 0;
	border-radius: 6px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 44px;
	color: ${hexToRgba(NewStyleColor.Black, 55)};
	text-align: center;
	background-color: ${NewStyleColor.White};
	cursor: pointer;
`;

const ButtonsList = styled('ul')`
	margin: 0;
	padding: 0;
	list-style-type: none;

	li:not(:last-child) {
		margin-bottom: 4px;
	}
`;

const ResourceType = styled('span')`
	display: block;
	margin-top: 8px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 16px;
	color: ${hexToRgba(NewStyleColor.Black, 55)};
	text-transform: uppercase;

	span {
		text-transform: none;
	}
`;

export {
	Label,
	Button,
	ButtonsList,
	ResourceType,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/styles.ts